import type { ManuscriptNode } from "@contract";

/** Directly formatted DOCX titles can be paragraphs; audition actual prose. */
export function samplePassage<T extends Pick<ManuscriptNode, "text" | "type">>(
  nodes: readonly T[],
  chapterTitle: string,
): T | undefined {
  const plain = (text: string) => text.replaceAll("*", "").trim();
  const candidates = nodes.filter((node) => {
    const text = plain(node.text);
    return (
      (node.type === "paragraph" || node.type === "listItem") &&
      text.length > 0 &&
      text.length <= 4500 &&
      text !== plain(chapterTitle)
    );
  });
  return candidates.find((node) => plain(node.text).length >= 80) ?? candidates[0];
}
